module.exports = __webpack_public_path__ + "static/media/castle.700ca9c5.png";